import InfoButton from '../../../components/InfoButton/InfoButton'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'
import '../Section.css'

function MustCaptureMoments() {
  return (
    <div className="dashboard-section">
      <h1>
        Must-Capture Moments
        <InfoButton
          title="Must-Capture Moments"
          content={
            <div>
              <p>
                Create a shot list for your photographer. List all the moments, people, and details 
                you want captured so nothing gets forgotten (and no one says "we missed the confetti photo").
              </p>
              <p>
                <strong>Features:</strong>
              </p>
              <ul>
                <li>Pre-filled shot list templates</li>
                <li>Add custom moments and details</li>
                <li>Organize by ceremony, reception, or timeline</li>
                <li>Share with your photographer</li>
                <li>Check off captured moments on the day</li>
              </ul>
              <p>
                All in one place, stress-free.
              </p>
            </div>
          }
        />
      </h1>
      <ComingSoon messageIndex={0} />
    </div>
  )
}

export default MustCaptureMoments
